import { jwtDecode } from "jwt-decode";
import getRole from "./RoleService";

const uri = `${import.meta.env.VITE_BASE_URL}/api/achievement`;

const CreateAchievement = async (userId,name, type, points, dateAchieved) => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;
      const formData = new FormData();
      formData.append("userId", userId);
      formData.append("name", name);
      formData.append("description", "");
      formData.append("type", type);
      formData.append("points", points);
      formData.append("dateAchieved", dateAchieved);
      const response = await fetch(`${uri}/create-achievement`, {
        method: "post",
        headers: {
          authorization: `Bearer ${token}`,
        },
        body: formData,
      });
      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Lỗi server" };
  }
};

export { CreateAchievement };
